import React from 'react';
import { CreditCard, Shield, Award, Clock } from 'lucide-react';

const TrustBadgesSection = () => {
  return (
    <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        {/* Payment Methods */}
        <div className="mb-8">
          <div className="flex items-center gap-2 justify-center mb-6">
            <CreditCard className="w-6 h-6" style={{ color: '#00B3B3' }} />
            <h3 className="text-2xl font-bold text-gray-900">We Accept</h3>
          </div>
          
          {/* All Payment Options */}
          <div className="flex flex-wrap gap-3 justify-center items-center max-w-5xl mx-auto">
            {/* Credit Cards */}
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-blue-600 font-bold">VISA</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-orange-500 font-bold">Mastercard</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-blue-500 font-bold">American Express</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-purple-600 font-bold">Discover</span>
            </div>
            
            {/* Digital Wallets */}
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-gray-700 font-semibold">Apple Pay</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-gray-700 font-semibold">Google Pay</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-gray-700 font-semibold">Samsung Pay</span>
            </div>
            
            {/* P2P Payments */}
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-purple-600 font-semibold">Zelle</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-green-600 font-semibold">Cash App</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-blue-500 font-semibold">Venmo</span>
            </div>
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-blue-600 font-semibold">PayPal</span>
            </div>
            
            {/* Cash */}
            <div className="bg-white px-4 py-2 rounded shadow-sm border border-gray-200">
              <span className="text-gray-700 font-bold">Cash</span>
            </div>
          </div>
        </div>

        {/* Financing Options */}
        <div className="mb-8">
          <div className="text-center mb-4">
            <h4 className="text-lg font-bold text-gray-900">Financing & Lease-to-own Available</h4>
          </div>
          <div className="flex flex-wrap gap-3 justify-center items-center">
            <div className="bg-white px-6 py-3 rounded shadow-md border-2" style={{ borderColor: '#00B3B3' }}>
              <span className="text-gray-900 font-bold text-lg">Afterpay</span>
            </div>
            <div className="bg-white px-6 py-3 rounded shadow-md border-2" style={{ borderColor: '#00B3B3' }}>
              <span className="text-gray-900 font-bold text-lg">Acima Leasing</span>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap gap-6 justify-center pt-6 border-t border-gray-300">
          <div className="flex items-center gap-2 text-gray-700">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(0, 179, 179, 0.1)' }}>
              <Shield className="w-5 h-5" style={{ color: '#00B3B3' }} />
            </div>
            <div className="text-left">
              <p className="font-bold text-sm">Licensed &</p>
              <p className="font-bold text-sm">Insured</p>
            </div>
          </div>

          <div className="flex items-center gap-2 text-gray-700">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(0, 179, 179, 0.1)' }}>
              <Award className="w-5 h-5" style={{ color: '#00B3B3' }} />
            </div>
            <div className="text-left">
              <p className="font-bold text-sm">OEM</p>
              <p className="font-bold text-sm">Certified</p>
            </div>
          </div>

          <div className="flex items-center gap-2 text-gray-700">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(0, 179, 179, 0.1)' }}>
              <Clock className="w-5 h-5" style={{ color: '#00B3B3' }} />
            </div>
            <div className="text-left">
              <p className="font-bold text-sm">Same-Day</p>
              <p className="font-bold text-sm">Service</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;
